import { ListImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/listImpression.trackingInfo";
import { toChunks } from "@omni/utils/array.utils";

import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaViewPayload
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsContentListImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaViewPayload> {}

const getAlgoliaContentViewedPayload = (
    eventData: ListImpressionTrackingInfo,
    objectIDs: Array<string>
): AlgoliaViewPayload => {
    return {
        authenticatedUserToken: AlgoliaUserService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.HitsViewed,
        index: eventData.meta.index,
        userToken: AlgoliaUserService.getUserToken(),
        objectIDs
    };
};

const getAlgoliaAnalyticsContentListmpression = (
    data: TypedAnalyticsEvent<ListImpressionTrackingInfo>
): Array<AlgoliaAnalyticsContentListImpression> => {
    const chunks = toChunks(data.payload.eventData.ids, 20);
    return chunks.map((chunk) => ({
        eventName: AlgoliaAnalyticsEvents.ViewedObjectIDs,
        payload: getAlgoliaContentViewedPayload(data.payload.eventData, chunk)
    }));
};

export { getAlgoliaAnalyticsContentListmpression };
